import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const SalesFilter = ({ value, onChange, testId = "sales-filter" }) => {
  const { isAdmin } = useAuth();
  const [users, setUsers] = useState([]);
  useEffect(() => {
    if (isAdmin) api.get("/users").then((r) => setUsers(r.data));
  }, [isAdmin]);
  if (!isAdmin) return null;
  return (
    <select className="h-10 rounded-md border border-input bg-white px-3 text-sm" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      <option value="">Semua Sales</option>
      {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
    </select>
  );
};
